import {loginUrl} from "../../../utils/env";
import React from "react";

interface AlreadyHaveAnAccountProps {
    redirectTo?: string | null;
}

const AlreadyHaveAnAccount=({redirectTo = null}: AlreadyHaveAnAccountProps)=>{
    const encodedTo = redirectTo? encodeURIComponent(redirectTo) : ""

    return(
        <div className="SignInLink">
            Already have an account?&nbsp;
            <a href={`${loginUrl}?redirect_to=${encodedTo}`} rel="noreferrer" tabIndex={0} className="SignIn" aria-label="Sign in" role="button">
                Sign in
            </a>
        </div>
    );
}
export default AlreadyHaveAnAccount;
